import Vue from 'vue'

const actions = {
  showSuccess(_, message) {
    Vue.toasted.show(message, {
      type: 'success',
      duration: 5000,
      action: {
        text: '✕',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        }
      }
    })
  },
  showError(_, message) {
    Vue.toasted.show(message, {
      type: 'error',
      duration: 5000,
      action: {
        text: '✕',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        }
      }
    })
  }
}

export default {
  namespaced: true,
  state: {},
  actions,
  mutations: {}
}
